"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const fonts_1 = __importDefault(require("./fonts"));
const sizes_1 = __importDefault(require("./sizes"));
const colors_1 = __importDefault(require("./colors"));
const _TextStyles = {
    btn: {
        fontFamily: fonts_1.default.bold,
        fontSize: sizes_1.default.body3,
        lineHeight: 22,
    },
    btnSm: {
        fontSize: sizes_1.default.body4,
        lineHeight: 22,
    },
};
const _modalTitle = {
    fontFamily: fonts_1.default.bold,
    fontSize: sizes_1.default.body2,
    color: colors_1.default.colorTextPrimary,
    lineHeight: 22,
    textAlign: "center",
};
const TextStyles = {
    ..._TextStyles,
    body1: {
        fontFamily: fonts_1.default.regular,
        fontSize: sizes_1.default.body1,
        color: colors_1.default.colorTextPrimary,
        lineHeight: 36,
    },
    body2: {
        fontFamily: fonts_1.default.regular,
        fontSize: sizes_1.default.body2,
        color: colors_1.default.colorTextPrimary,
        lineHeight: 30,
    },
    body3: {
        fontFamily: fonts_1.default.regular,
        fontSize: sizes_1.default.body3,
        color: colors_1.default.colorTextPrimary,
        lineHeight: 22,
    },
    body4: {
        fontFamily: fonts_1.default.regular,
        fontSize: sizes_1.default.body4,
        color: colors_1.default.colorTextPrimary,
        lineHeight: 22,
    },
    body5: {
        fontFamily: fonts_1.default.regular,
        fontSize: sizes_1.default.body5,
        color: colors_1.default.colorTextPrimary,
        lineHeight: 22,
    },
    btnPrimary: {
        ..._TextStyles.btn,
        color: colors_1.default.colorBtnPrimaryText,
    },
    btnSecondary: {
        ..._TextStyles.btn,
        color: colors_1.default.colorVividYellow1,
    },
    txtMenuTitle: {
        fontFamily: fonts_1.default.bold,
        fontSize: sizes_1.default.body1,
        color: colors_1.default.colorTextPrimary,
        lineHeight: 36,
    },
    modalTitle: {
        ..._modalTitle,
    },
};
exports.default = TextStyles;
